import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import { AiFillGithub, AiOutlineTwitter, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home() {
  return (
    <section style={{ backgroundColor: "#0a0a23", color: "white" }}>
      {/* HERO SECTION */}
      <div style={{ position: "relative", overflow: "hidden" }}>
        <Particle />
        <Container
          fluid
          id="home"
          style={{
            position: "relative",
            zIndex: 2,
            minHeight: "100vh",
            paddingTop: "80px",
            paddingBottom: "60px",
          }}
        >
          <Row className="align-items-center">
            {/* LEFT SIDE: Text */}
<Col
  md={7}
  sm={12}
  className="text-start"
  style={{
    paddingTop: "100px",
    paddingBottom: "50px",
    paddingLeft: "60px", // add this line
  }}
>
  <h1 className="heading mb-3" style={{ fontSize: "2.5rem" }}>
    Hi there{" "}
    <span className="wave" role="img" aria-labelledby="wave">
      👋🏻
    </span>
  </h1>

  <h1
    className="heading-name mb-4"
    style={{
      fontSize: "2.8rem",
      fontWeight: "700",
      lineHeight: "1.2",
    }}
  >
    I'M <strong className="main-name purple">Jeff Akin</strong>
  </h1>

  <div style={{ paddingTop: 30, maxWidth: "480px" }}>
    <Type />
  </div>
</Col>


            {/* RIGHT SIDE: Image */}
            <Col md={5} sm={12} className="text-center">
              <img
                src={homeLogo}
                alt="Shaun K Profile Illustration"
                className="img-fluid"
                style={{
                  maxHeight: "420px",
                  width: "100%",
                  objectFit: "contain",
                  marginTop: "60px",
                }}
              />
            </Col>
          </Row>
        </Container>
      </div>

      {/* SECONDARY INTRO SECTION */}
      <div
        style={{
          backgroundColor: "#0f0f25",
          position: "relative",
          zIndex: 2,
          paddingTop: "50px",
          paddingBottom: "50px",
        }}
      >
        <Home2 />
      </div>

      {/* SOCIAL SECTION */}
      <Container
        style={{
          position: "relative",
          zIndex: 2,
          backgroundColor: "#0a0a23",
          paddingTop: "70px",
          paddingBottom: "80px",
        }}
      >
        <Row>
          <Col md={12} className="home-about-social text-center">
            <h1 className="mb-3">Find Me On</h1>
            <p style={{ color: "#aaa" }}>
              Feel free to <span className="purple">connect</span> with me.
            </p>
            <ul
              className="home-about-social-links d-flex justify-content-center flex-wrap"
              style={{ listStyle: "none", padding: 0 }}
            >
              <li className="social-icons m-3">
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub size={30} />
                </a>
              </li>
              <li className="social-icons m-3">
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineTwitter size={30} />
                </a>
              </li>
              <li className="social-icons m-3">
                <a
                  href="https://www.linkedin.com/in/jeff-akin/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn size={30} />
                </a>
              </li>
              <li className="social-icons m-3">
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram size={30} />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;
